"use client";

import { getSpacing } from "@faire/web/slate/spacing";
import { ToastContainer as ToastContainerSlate } from "@faire/web/slate/Toast";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";

export const ToastContainer = () => {
  const viewport = useViewport();
  return (
    <ToastContainerSlate
      position={viewport.isMobile ? "bottom-center" : "top-right"}
      style={
        viewport.isMobile
          ? undefined
          : {
              position: "absolute",
              top: "initial",
              bottom: getSpacing("-3x"),
              right: getSpacing("3x"),
              left: "auto",
              width: "fit-content",
              height: "fit-content",
              padding: "0",
              zIndex: 11,
              maxWidth: "325px",
              transform: "translateY(100%)",
            }
      }
    />
  );
};
